import { Autocomplete } from "src/components/shared/MantineCombobox";
import { useController, useFormContext } from "react-hook-form";

import { useGetApi, useIsOnline } from "../../hooks";
import { Flex } from "../../styled";
import { getYachtId } from "../../utils";
import FileAttachment from "../FileAttachment/FileAttachment";
import { getValue } from "./caseReport.utils";
import CaseReportButton from "./CaseReportButton";
import { useLogbookRefsContext } from "../Logbook/LogbookRefsContext";
import MultipleAttachments from "../MultipleAttachments/MultipleAttachments";

interface Props {
  id: string;
  value:
    | {
        caseno: string;
        report: {
          filename: string;
          filetype: string;
          b64: string;
        }[];
      }
    | string;
  required: boolean;
}
const mapSearch = (data: any) => {
  if (!data?.list || data.list.length < 2) return [];
  return data.list.map((item: any) => ({
    value: item.caseno,
    label: item.caseno,
  }));
};

const CaseReportInput = ({ id, value, required }: Props) => {
  const isOnline = useIsOnline();
  const { control, setValue } = useFormContext();

  const defaultValue = getValue(value);

  const { field } = useController({
    control,
    name: `${id}.caseno`,
    defaultValue: defaultValue.caseno,
  });
  const { field: filesData } = useController({
    control,
    name: `${id}.report`,
    defaultValue: defaultValue.report,
  });

  const { data, refetch } = useGetApi({
    request: "search-case-reports",
    body: {
      params: {
        yachtid: getYachtId(),
        caseno: field.value ?? "",
      },
    },
    fetchOnInit: false,
    mapper: mapSearch,
  });

  const logbookRefsProps = useLogbookRefsContext(`${id}.caseno`);

  const handleSearch = (v: string) => {
    if (isOnline) void refetch();
    setValue(`${id}.caseno`, v);
  };

  return (
    <Flex direction="column" gap={10}>
      <Flex gap={10} align="end">
        <Autocomplete
          {...logbookRefsProps}
          data={data ?? []}
          value={field.value}
          onChange={handleSearch}
          label="Search by case number"
          labelProps={{ style: { marginLeft: 2 } }}
        />
        {isOnline && <CaseReportButton caseNumber={field.value} />}
      </Flex>
      <MultipleAttachments
        id={`${id}.report`}
        value={
          Array.isArray(filesData.value) ? filesData.value : [filesData.value]
        }
      />
    </Flex>
  );
};
export default CaseReportInput;
